import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SaveIcon from '@material-ui/icons/Save';

import { useFormularioContext } from '../../commons/Formulario';
import { confirmacion, mensaje, mensajeMini } from '../../commons/Mensajes';

import Boton from '../../commons/Boton';
import Calendario from '../../commons/Calendario';
import CheckBox from '../../commons/CheckBox';
import GroupText from '../../commons/GroupText';
import MaterialCommunityIcons from '../../commons/Icons/MaterialCommunityIcons';
import Loading from '../../commons/Loading';
import Texto from '../../commons/Texto';
import { formatoFecha } from '../../commons/Utilitarios';

import useMantenimiento from '../../hooks/useMantenimiento';

import { testingDetailRequest } from '../../redux/models/mantenimiento.model';

const MaintenanceResults = ({ equipment, previusEquipment, onSave }) => {
  const { selected, accionTask } = useFormularioContext();
  const { postMaintenanceResult } = useMantenimiento();
  const [results, setResults] = useState([]);
  const [process, setProcess] = useState(false);

  useEffect(() => {
    let res = [];
    equipment.ts
      .filter(() => previusEquipment?.ts?.length === 0)
      .map((x) => {
        res.push({
          title: x.nt,
          data: x.lt
            ? x.lt.map((y) => ({
                te: x.te,
                tp: x.nt,
                co: y.co,
                nt: y.nt,
                td: y.td,
                rs: undefined,
              }))
            : [],
        });
      });
    previusEquipment?.ts?.map((x) => {
      const exist = res.find((r) => r.title === x.tp);
      if (exist) {
        exist.data = [
          ...exist.data,
          {
            te: '',
            tp: x.nt,
            co: x.co,
            nt: x.nt,
            td: {
              vm: '99',
              de: '',
              dt: '',
            },
            rs: x.rs,
          },
        ];
      } else {
        res.push({
          title: x.tp,
          data: [
            {
              te: '',
              tp: x.nt,
              co: x.co,
              nt: x.nt,
              td: {
                vm: '99',
                de: '',
                dt: '',
              },
              rs: x.rs,
            },
          ],
        });
      }
    });
    setResults(res);
  }, []);

  /**
   * Obtener el componente de consulta.
   * @param {string} title cabecera del resultado
   * @param {object} question objeto resultado
   * @returns componente de resultado
   */
  const getQuestionComponent = (title, question) => {
    switch (question.td.vm) {
      case '01':
      case '02':
      case '03':
        return (
          <Texto
            key={question.co}
            label={question.nt}
            name={question.nt}
            tabIndex={12}
            restrict={question.td.vm === '01' ? 'texto' : 'int'}
            value={question.rs}
            onChange={({ value }) => handleChange(title, question.co, value)}
            icon={() => (
              <MaterialCommunityIcons
                name={question.td.vm === '01' ? 'alphabetical' : 'numeric'}
                size={20}
              />
            )}
          />
        );
      case '04':
      case '05':
        return (
          <Calendario
            key={question.co}
            label={question.nt}
            name={question.nt}
            value={question.rs}
            showTime={question.td.vm === '05'}
            closeOnSelectTime
            onSelected={({ value }) => handleChange(title, question.co, value)}
          />
        );
      case '09':
        return (
          <div key={question.co} className="op-form-group op-checkbox-group">
            <span>{question.nt}</span>
            <CheckBox
              name={question.nt}
              checked={question.rs}
              onChange={({ value }) => handleChange(title, question.co, value)}
            />
          </div>
        );
      default:
        return (
          <GroupText
            key={question.co}
            label={question.nt}
            text={question.rs}
            icon={
              <MaterialCommunityIcons
                name={'checkbox-marked-circle-outline'}
                size={20}
                color={'green'}
              />
            }
            invert
          />
        );
    }
  };

  /**
   * evento para cambios del resultado.
   * @param {string} title cabecera del resultado
   * @param {string} co identificador de resultado
   * @param {string | undefined} value valor del resultado
   */
  const handleChange = (title, co, value) => {
    setResults(
      results.map((x) =>
        x.title === title
          ? {
              ...x,
              data: x.data.map((y) => (y.co === co ? { ...y, rs: value } : y)),
            }
          : x
      )
    );
  };

  /**
   * Transformar valores de resultados.
   * @param {testingDetailRequest} result objeto a transformar
   * @returns result
   */
  const handleTransform = (result) => {
    switch (result.td.vm) {
      case '04':
      case '05':
        return {
          ...result,
          rs: formatoFecha(result.rs, '', result.td.vm === '05'),
        };
      case '09':
        return { ...result, rs: result.rs === true ? 'Si' : 'No' };
      default:
        return result;
    }
  };

  const handleSaveResults = async () => {
    setProcess(true);
    let response = await postMaintenanceResult({
      eq: equipment.eq.eq,
      ia: accionTask,
      so: selected.so,
      lr: results.flatMap((x) => x.data).map((x) => handleTransform(x)),
    });
    if (response.success && response.status === 'success') {
      mensaje('Operación Satisfactoria');
      onSave();
    } else if (response.messageError) {
      mensajeMini(response.messageError);
    } else if (response.fieldsErrors) {
      mensajeMini(Object.values(response.fieldsErrors)[0]);
    }
    setProcess(false);
  };

  return (
    <div>
      {process && <Loading tipo={'request'} />}
      {!previusEquipment?.fa && (
        <div className="op-form-group">
          <Boton
            className="op-grabar"
            icon={() => <SaveIcon />}
            onClick={() =>
              confirmacion(
                '¿Está seguro?',
                `De registrar los resultados del equipo ${equipment.eq.ne}, recuerde que ya no podra volver a enviar esta información`
              )
                .then(() => handleSaveResults())
                .catch(() => {})
            }
          >
            Registrar resultados
          </Boton>
        </div>
      )}
      {results
        .filter((r) => r.data.length > 0)
        .map((header) => (
          <div key={header.title} style={{ marginBottom: '10px' }}>
            <p>
              <strong>{header.title}</strong>
            </p>
            {header.data.map((d) => getQuestionComponent(header.title, d))}
          </div>
        ))}
    </div>
  );
};

MaintenanceResults.propTypes = {
  equipment: PropTypes.object,
  previusEquipment: PropTypes.object,
  onSave: PropTypes.func,
};

export default MaintenanceResults;
